import { useState } from 'react'
import { Marker, Popup, useMapEvents } from 'react-leaflet'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { appendPoint } from '../../../state/path/path.actions'
import { selectPath } from '../../../state/path/path.selectors'

const LocationMarkerComponent = (props: any) => {
  // todo: move useState to redux
  const [position, setPosition] = useState(null)
  const map = useMapEvents({
    click(l) {
      map.locate()
      props.appendPoint(l.latlng)
      console.log(props.path)
    },
    // locationfound(e: any) {
    //   setPosition(e.latlng)
    //   map.flyTo(e.latlng, map.getZoom())
    // },
  })

  return position === null ? null : (
    <Marker position={position}>
      <Popup>You are here</Popup>
    </Marker>
  )
}
const stateProps = createStructuredSelector({
  path: selectPath,
})

const dispatchProps = {
  appendPoint,
}

export const LocationMarker = connect(
  stateProps,
  dispatchProps
)(LocationMarkerComponent)
